var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"logout",attrs:{"title":_vm._f("translate")('Odhlášení')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v("Odhlášení\n\t\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b50ef73e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = h/i4
// module chunks = 0